import { useCallback, useState } from 'react';
import { playSound, Sound } from '~/assets/sounds';
import {
	TextInputAlign,
	TextInput as TextInputComponent,
} from '~/components/ui/TextInput';
import en from '../../assets/images/en.svg';
import ru from '../../assets/images/ru.svg';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import { setPasswordVisible } from '../../redux/slices/formDataSlice';
import { ErrorBanner } from '../ErrorBanner';
import { detectLayout, ITextInputProps } from './TextInput.model';
import {
	StyledContainer,
	StyledLangImage,
	StyledPasswordEye,
} from './TextInput.styled';

const TextInput = ({ name, error, ...props }: ITextInputProps) => {
	const passwordVisible = useLayoutSelector(
		(state) => state.formData.passwordVisible,
	);
	const dispatch = useLayoutDispatch();
	const [layout, setLayout] = useState('');

	const handleOnChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const lastCharacter = event.target.value.slice(-1);
			const detectedLayout = detectLayout(lastCharacter);
			if (detectedLayout) {
				setLayout(detectedLayout);
			}

			props.onChange?.(event);
		},
		[props],
	);

	let type = 'text';
	if (name.includes('password') && !passwordVisible) {
		type = 'password';
	}

	return (
		<StyledContainer $invalid={error !== undefined}>
			<TextInputComponent
				height={50}
				fontSize={16}
				textAlign={TextInputAlign.Center}
				name={name}
				type={type}
				autoComplete="off"
				onMouseEnter={() => playSound(Sound.LinkCursor)}
				{...props}
				onChange={(e) => handleOnChange(e)}
			/>
			{error && <ErrorBanner>{error}</ErrorBanner>}
			<StyledLangImage
				src={layout === 'ru' ? ru : layout === 'en' ? en : undefined}
				style={{ right: name.includes('password') ? 60 : 20 }}
			/>
			{name.includes('password') && (
				<StyledPasswordEye
					onClick={() => {
						dispatch(setPasswordVisible(!passwordVisible));
						playSound(Sound.ClickButton);
					}}
					onMouseEnter={() => playSound(Sound.LinkCursor)}
				/>
			)}
		</StyledContainer>
	);
};

export { TextInput };
